export const percyColumn = (options) => {
    var _a;
    const result = document.createElement('percy-column');
    result.style.gap = (_a = options.gap) !== null && _a !== void 0 ? _a : '8px';
    options.children.forEach((child) => {
        result.appendChild(child);
    });
    return result;
};
